export default __webpack_public_path__ + "static/media/star.5aa4edb4.svg";